const state = {
    telephoneCodes: [
        {
        "name": "Afghanistan",
        "number": "+93",
        "countryCode": "AF"
        },
        {
        "name": "Åland Islands",
        "number": "+358",
        "countryCode": "AX"
        },
        {
        "name": "Albania",
        "number": "+355",
        "countryCode": "AL"
        },
        {
        "name": "Algeria",
        "number": "+213",
        "countryCode": "DZ"
        },
        {
        "name": "American Samoa",
        "number": "+1684",
        "countryCode": "AS"
        },
        {
        "name": "Andorra",
        "number": "+376",
        "countryCode": "AD"
        },
        {
        "name": "Angola",
        "number": "+244",
        "countryCode": "AO"
        },
        {
        "name": "Anguilla",
        "number": "+1264",
        "countryCode": "AI"
        },
        {
        "name": "Antarctica",
        "number": "+672",
        "countryCode": "AQ"
        },
        {
        "name": "Antigua and Barbuda",
        "number": "+1268",
        "countryCode": "AG"
        },
        {
        "name": "Argentina",
        "number": "+54",
        "countryCode": "AR"
        },
        {
        "name": "Armenia",
        "number": "+374",
        "countryCode": "AM"
        },
        {
        "name": "Aruba",
        "number": "+297",
        "countryCode": "AW"
        },
        {
        "name": "Australia",
        "number": "+61",
        "countryCode": "AU"
        },
        {
        "name": "Austria",
        "number": "+43",
        "countryCode": "AT"
        },
        {
        "name": "Azerbaijan",
        "number": "+994",
        "countryCode": "AZ"
        },
        {
        "name": "Bahamas",
        "number": "+1242",
        "countryCode": "BS"
        },
        {
        "name": "Bahrain",
        "number": "+973",
        "countryCode": "BH"
        },
        {
        "name": "Bangladesh",
        "number": "+880",
        "countryCode": "BD"
        },
        {
        "name": "Barbados",
        "number": "+1246",
        "countryCode": "BB"
        },
        {
        "name": "Belarus",
        "number": "+375",
        "countryCode": "BY"
        },
        {
        "name": "Belgium",
        "number": "+32",
        "countryCode": "BE"
        },
        {
        "name": "Belize",
        "number": "+501",
        "countryCode": "BZ"
        },
        {
        "name": "Benin",
        "number": "+229",
        "countryCode": "BJ"
        },
        {
        "name": "Bermuda",
        "number": "+1441",
        "countryCode": "BM"
        },
        {
        "name": "Bhutan",
        "number": "+975",
        "countryCode": "BT"
        },
        {
        "name": "Bolivia, Plurinational State of bolivia",
        "number": "+591",
        "countryCode": "BO"
        },
        {
        "name": "Bosnia and Herzegovina",
        "number": "+387",
        "countryCode": "BA"
        },
        {
        "name": "Botswana",
        "number": "+267",
        "countryCode": "BW"
        },
        {
        "name": "Bouvet Island",
        "number": "+47",
        "countryCode": "BV"
        },
        {
        "name": "Brazil",
        "number": "+55",
        "countryCode": "BR"
        },
        {
        "name": "British Indian Ocean Territory",
        "number": "+246",
        "countryCode": "IO"
        },
        {
        "name": "Brunei Darussalam",
        "number": "+673",
        "countryCode": "BN"
        },
        {
        "name": "Bulgaria",
        "number": "+359",
        "countryCode": "BG"
        },
        {
        "name": "Burkina Faso",
        "number": "+226",
        "countryCode": "BF"
        },
        {
        "name": "Burundi",
        "number": "+257",
        "countryCode": "BI"
        },
        {
        "name": "Cambodia",
        "number": "+855",
        "countryCode": "KH"
        },
        {
        "name": "Cameroon",
        "number": "+237",
        "countryCode": "CM"
        },
        {
        "name": "Canada",
        "number": "+1",
        "countryCode": "CA"
        },
        {
        "name": "Cape Verde",
        "number": "+238",
        "countryCode": "CV"
        },
        {
        "name": "Cayman Islands",
        "number": "+ 345",
        "countryCode": "KY"
        },
        {
        "name": "Central African Republic",
        "number": "+236",
        "countryCode": "CF"
        },
        {
        "name": "Chad",
        "number": "+235",
        "countryCode": "TD"
        },
        {
        "name": "Chile",
        "number": "+56",
        "countryCode": "CL"
        },
        {
        "name": "China",
        "number": "+86",
        "countryCode": "CN"
        },
        {
        "name": "Christmas Island",
        "number": "+61",
        "countryCode": "CX"
        },
        {
        "name": "Cocos (Keeling) Islands",
        "number": "+61",
        "countryCode": "CC"
        },
        {
        "name": "Colombia",
        "number": "+57",
        "countryCode": "CO"
        },
        {
        "name": "Comoros",
        "number": "+269",
        "countryCode": "KM"
        },
        {
        "name": "Congo",
        "number": "+242",
        "countryCode": "CG"
        },
        {
        "name": "Congo, The Democratic Republic of the Congo",
        "number": "+243",
        "countryCode": "CD"
        },
        {
        "name": "Cook Islands",
        "number": "+682",
        "countryCode": "CK"
        },
        {
        "name": "Costa Rica",
        "number": "+506",
        "countryCode": "CR"
        },
        {
        "name": "Cote d'Ivoire",
        "number": "+225",
        "countryCode": "CI"
        },
        {
        "name": "Croatia",
        "number": "+385",
        "countryCode": "HR"
        },
        {
        "name": "Cuba",
        "number": "+53",
        "countryCode": "CU"
        },
        {
        "name": "Cyprus",
        "number": "+357",
        "countryCode": "CY"
        },
        {
        "name": "Czech Republic",
        "number": "+420",
        "countryCode": "CZ"
        },
        {
        "name": "Denmark",
        "number": "+45",
        "countryCode": "DK"
        },
        {
        "name": "Djibouti",
        "number": "+253",
        "countryCode": "DJ"
        },
        {
        "name": "Dominica",
        "number": "+1767",
        "countryCode": "DM"
        },
        {
        "name": "Dominican Republic",
        "number": "+1849",
        "countryCode": "DO"
        },
        {
        "name": "Ecuador",
        "number": "+593",
        "countryCode": "EC"
        },
        {
        "name": "Egypt",
        "number": "+20",
        "countryCode": "EG"
        },
        {
        "name": "El Salvador",
        "number": "+503",
        "countryCode": "SV"
        },
        {
        "name": "Equatorial Guinea",
        "number": "+240",
        "countryCode": "GQ"
        },
        {
        "name": "Eritrea",
        "number": "+291",
        "countryCode": "ER"
        },
        {
        "name": "Estonia",
        "number": "+372",
        "countryCode": "EE"
        },
        {
        "name": "Ethiopia",
        "number": "+251",
        "countryCode": "ET"
        },
        {
        "name": "Falkland Islands (Malvinas)",
        "number": "+500",
        "countryCode": "FK"
        },
        {
        "name": "Faroe Islands",
        "number": "+298",
        "countryCode": "FO"
        },
        {
        "name": "Fiji",
        "number": "+679",
        "countryCode": "FJ"
        },
        {
        "name": "Finland",
        "number": "+358",
        "countryCode": "FI"
        },
        {
        "name": "France",
        "number": "+33",
        "countryCode": "FR"
        },
        {
        "name": "French Guiana",
        "number": "+594",
        "countryCode": "GF"
        },
        {
        "name": "French Polynesia",
        "number": "+689",
        "countryCode": "PF"
        },
        {
        "name": "French Southern Territories",
        "number": "+262",
        "countryCode": "TF"
        },
        {
        "name": "Gabon",
        "number": "+241",
        "countryCode": "GA"
        },
        {
        "name": "Gambia",
        "number": "+220",
        "countryCode": "GM"
        },
        {
        "name": "Georgia",
        "number": "+995",
        "countryCode": "GE"
        },
        {
        "name": "Germany",
        "number": "+49",
        "countryCode": "DE"
        },
        {
        "name": "Ghana",
        "number": "+233",
        "countryCode": "GH"
        },
        {
        "name": "Gibraltar",
        "number": "+350",
        "countryCode": "GI"
        },
        {
        "name": "Greece",
        "number": "+30",
        "countryCode": "GR"
        },
        {
        "name": "Greenland",
        "number": "+299",
        "countryCode": "GL"
        },
        {
        "name": "Grenada",
        "number": "+1473",
        "countryCode": "GD"
        },
        {
        "name": "Guadeloupe",
        "number": "+590",
        "countryCode": "GP"
        },
        {
        "name": "Guam",
        "number": "+1671",
        "countryCode": "GU"
        },
        {
        "name": "Guatemala",
        "number": "+502",
        "countryCode": "GT"
        },
        {
        "name": "Guernsey",
        "number": "+44",
        "countryCode": "GG"
        },
        {
        "name": "Guinea",
        "number": "+224",
        "countryCode": "GN"
        },
        {
        "name": "Guinea-Bissau",
        "number": "+245",
        "countryCode": "GW"
        },
        {
        "name": "Guyana",
        "number": "+592",
        "countryCode": "GY"
        },
        {
        "name": "Haiti",
        "number": "+509",
        "countryCode": "HT"
        },
        {
        "name": "Heard Island and Mcdonald Islands",
        "number": "+0",
        "countryCode": "HM"
        },
        {
        "name": "Holy See (Vatican City State)",
        "number": "+379",
        "countryCode": "VA"
        },
        {
        "name": "Honduras",
        "number": "+504",
        "countryCode": "HN"
        },
        {
        "name": "Hong Kong",
        "number": "+852",
        "countryCode": "HK"
        },
        {
        "name": "Hungary",
        "number": "+36",
        "countryCode": "HU"
        },
        {
        "name": "Iceland",
        "number": "+354",
        "countryCode": "IS"
        },
        {
        "name": "India",
        "number": "+91",
        "countryCode": "IN"
        },
        {
        "name": "Indonesia",
        "number": "+62",
        "countryCode": "ID"
        },
        {
        "name": "Iran, Islamic Republic of Persian Gulf",
        "number": "+98",
        "countryCode": "IR"
        },
        {
        "name": "Iraq",
        "number": "+964",
        "countryCode": "IQ"
        },
        {
        "name": "Ireland",
        "number": "+353",
        "countryCode": "IE"
        },
        {
        "name": "Isle of Man",
        "number": "+44",
        "countryCode": "IM"
        },
        {
        "name": "Israel",
        "number": "+972",
        "countryCode": "IL"
        },
        {
        "name": "Italy",
        "number": "+39",
        "countryCode": "IT"
        },
        {
        "name": "Jamaica",
        "number": "+1876",
        "countryCode": "JM"
        },
        {
        "name": "Japan",
        "number": "+81",
        "countryCode": "JP"
        },
        {
        "name": "Jersey",
        "number": "+44",
        "countryCode": "JE"
        },
        {
        "name": "Jordan",
        "number": "+962",
        "countryCode": "JO"
        },
        {
        "name": "Kazakhstan",
        "number": "+7",
        "countryCode": "KZ"
        },
        {
        "name": "Kenya",
        "number": "+254",
        "countryCode": "KE"
        },
        {
        "name": "Kiribati",
        "number": "+686",
        "countryCode": "KI"
        },
        {
        "name": "Korea, Democratic People's Republic of Korea",
        "number": "+850",
        "countryCode": "KP"
        },
        {
        "name": "Korea, Republic of South Korea",
        "number": "+82",
        "countryCode": "KR"
        },
        {
        "name": "Kosovo",
        "number": "+383",
        "countryCode": "XK"
        },
        {
        "name": "Kuwait",
        "number": "+965",
        "countryCode": "KW"
        },
        {
        "name": "Kyrgyzstan",
        "number": "+996",
        "countryCode": "KG"
        },
        {
        "name": "Laos",
        "number": "+856",
        "countryCode": "LA"
        },
        {
        "name": "Latvia",
        "number": "+371",
        "countryCode": "LV"
        },
        {
        "name": "Lebanon",
        "number": "+961",
        "countryCode": "LB"
        },
        {
        "name": "Lesotho",
        "number": "+266",
        "countryCode": "LS"
        },
        {
        "name": "Liberia",
        "number": "+231",
        "countryCode": "LR"
        },
        {
        "name": "Libyan Arab Jamahiriya",
        "number": "+218",
        "countryCode": "LY"
        },
        {
        "name": "Liechtenstein",
        "number": "+423",
        "countryCode": "LI"
        },
        {
        "name": "Lithuania",
        "number": "+370",
        "countryCode": "LT"
        },
        {
        "name": "Luxembourg",
        "number": "+352",
        "countryCode": "LU"
        },
        {
        "name": "Macao",
        "number": "+853",
        "countryCode": "MO"
        },
        {
        "name": "Macedonia",
        "number": "+389",
        "countryCode": "MK"
        },
        {
        "name": "Madagascar",
        "number": "+261",
        "countryCode": "MG"
        },
        {
        "name": "Malawi",
        "number": "+265",
        "countryCode": "MW"
        },
        {
        "name": "Malaysia",
        "number": "+60",
        "countryCode": "MY"
        },
        {
        "name": "Maldives",
        "number": "+960",
        "countryCode": "MV"
        },
        {
        "name": "Mali",
        "number": "+223",
        "countryCode": "ML"
        },
        {
        "name": "Malta",
        "number": "+356",
        "countryCode": "MT"
        },
        {
        "name": "Marshall Islands",
        "number": "+692",
        "countryCode": "MH"
        },
        {
        "name": "Martinique",
        "number": "+596",
        "countryCode": "MQ"
        },
        {
        "name": "Mauritania",
        "number": "+222",
        "countryCode": "MR"
        },
        {
        "name": "Mauritius",
        "number": "+230",
        "countryCode": "MU"
        },
        {
        "name": "Mayotte",
        "number": "+262",
        "countryCode": "YT"
        },
        {
        "name": "Mexico",
        "number": "+52",
        "countryCode": "MX"
        },
        {
        "name": "Micronesia, Federated States of Micronesia",
        "number": "+691",
        "countryCode": "FM"
        },
        {
        "name": "Moldova",
        "number": "+373",
        "countryCode": "MD"
        },
        {
        "name": "Monaco",
        "number": "+377",
        "countryCode": "MC"
        },
        {
        "name": "Mongolia",
        "number": "+976",
        "countryCode": "MN"
        },
        {
        "name": "Montenegro",
        "number": "+382",
        "countryCode": "ME"
        },
        {
        "name": "Montserrat",
        "number": "+1664",
        "countryCode": "MS"
        },
        {
        "name": "Morocco",
        "number": "+212",
        "countryCode": "MA"
        },
        {
        "name": "Mozambique",
        "number": "+258",
        "countryCode": "MZ"
        },
        {
        "name": "Myanmar",
        "number": "+95",
        "countryCode": "MM"
        },
        {
        "name": "Namibia",
        "number": "+264",
        "countryCode": "NA"
        },
        {
        "name": "Nauru",
        "number": "+674",
        "countryCode": "NR"
        },
        {
        "name": "Nepal",
        "number": "+977",
        "countryCode": "NP"
        },
        {
        "name": "Netherlands",
        "number": "+31",
        "countryCode": "NL"
        },
        {
        "name": "Netherlands Antilles",
        "number": "+599",
        "countryCode": "AN"
        },
        {
        "name": "New Caledonia",
        "number": "+687",
        "countryCode": "NC"
        },
        {
        "name": "New Zealand",
        "number": "+64",
        "countryCode": "NZ"
        },
        {
        "name": "Nicaragua",
        "number": "+505",
        "countryCode": "NI"
        },
        {
        "name": "Niger",
        "number": "+227",
        "countryCode": "NE"
        },
        {
        "name": "Nigeria",
        "number": "+234",
        "countryCode": "NG"
        },
        {
        "name": "Niue",
        "number": "+683",
        "countryCode": "NU"
        },
        {
        "name": "Norfolk Island",
        "number": "+672",
        "countryCode": "NF"
        },
        {
        "name": "Northern Mariana Islands",
        "number": "+1670",
        "countryCode": "MP"
        },
        {
        "name": "Norway",
        "number": "+47",
        "countryCode": "NO"
        },
        {
        "name": "Oman",
        "number": "+968",
        "countryCode": "OM"
        },
        {
        "name": "Pakistan",
        "number": "+92",
        "countryCode": "PK"
        },
        {
        "name": "Palau",
        "number": "+680",
        "countryCode": "PW"
        },
        {
        "name": "Palestinian Territory, Occupied",
        "number": "+970",
        "countryCode": "PS"
        },
        {
        "name": "Panama",
        "number": "+507",
        "countryCode": "PA"
        },
        {
        "name": "Papua New Guinea",
        "number": "+675",
        "countryCode": "PG"
        },
        {
        "name": "Paraguay",
        "number": "+595",
        "countryCode": "PY"
        },
        {
        "name": "Peru",
        "number": "+51",
        "countryCode": "PE"
        },
        {
        "name": "Philippines",
        "number": "+63",
        "countryCode": "PH"
        },
        {
        "name": "Pitcairn",
        "number": "+64",
        "countryCode": "PN"
        },
        {
        "name": "Poland",
        "number": "+48",
        "countryCode": "PL"
        },
        {
        "name": "Portugal",
        "number": "+351",
        "countryCode": "PT"
        },
        {
        "name": "Puerto Rico",
        "number": "+1939",
        "countryCode": "PR"
        },
        {
        "name": "Qatar",
        "number": "+974",
        "countryCode": "QA"
        },
        {
        "name": "Romania",
        "number": "+40",
        "countryCode": "RO"
        },
        {
        "name": "Russia",
        "number": "+7",
        "countryCode": "RU"
        },
        {
        "name": "Rwanda",
        "number": "+250",
        "countryCode": "RW"
        },
        {
        "name": "Reunion",
        "number": "+262",
        "countryCode": "RE"
        },
        {
        "name": "Saint Barthelemy",
        "number": "+590",
        "countryCode": "BL"
        },
        {
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "number": "+290",
        "countryCode": "SH"
        },
        {
        "name": "Saint Kitts and Nevis",
        "number": "+1869",
        "countryCode": "KN"
        },
        {
        "name": "Saint Lucia",
        "number": "+1758",
        "countryCode": "LC"
        },
        {
        "name": "Saint Martin",
        "number": "+590",
        "countryCode": "MF"
        },
        {
        "name": "Saint Pierre and Miquelon",
        "number": "+508",
        "countryCode": "PM"
        },
        {
        "name": "Saint Vincent and the Grenadines",
        "number": "+1784",
        "countryCode": "VC"
        },
        {
        "name": "Samoa",
        "number": "+685",
        "countryCode": "WS"
        },
        {
        "name": "San Marino",
        "number": "+378",
        "countryCode": "SM"
        },
        {
        "name": "Sao Tome and Principe",
        "number": "+239",
        "countryCode": "ST"
        },
        {
        "name": "Saudi Arabia",
        "number": "+966",
        "countryCode": "SA"
        },
        {
        "name": "Senegal",
        "number": "+221",
        "countryCode": "SN"
        },
        {
        "name": "Serbia",
        "number": "+381",
        "countryCode": "RS"
        },
        {
        "name": "Seychelles",
        "number": "+248",
        "countryCode": "SC"
        },
        {
        "name": "Sierra Leone",
        "number": "+232",
        "countryCode": "SL"
        },
        {
        "name": "Singapore",
        "number": "+65",
        "countryCode": "SG"
        },
        {
        "name": "Slovakia",
        "number": "+421",
        "countryCode": "SK"
        },
        {
        "name": "Slovenia",
        "number": "+386",
        "countryCode": "SI"
        },
        {
        "name": "Solomon Islands",
        "number": "+677",
        "countryCode": "SB"
        },
        {
        "name": "Somalia",
        "number": "+252",
        "countryCode": "SO"
        },
        {
        "name": "South Africa",
        "number": "+27",
        "countryCode": "ZA"
        },
        {
        "name": "South Sudan",
        "number": "+211",
        "countryCode": "SS"
        },
        {
        "name": "South Georgia and the South Sandwich Islands",
        "number": "+500",
        "countryCode": "GS"
        },
        {
        "name": "Spain",
        "number": "+34",
        "countryCode": "ES"
        },
        {
        "name": "Sri Lanka",
        "number": "+94",
        "countryCode": "LK"
        },
        {
        "name": "Sudan",
        "number": "+249",
        "countryCode": "SD"
        },
        {
        "name": "Suriname",
        "number": "+597",
        "countryCode": "SR"
        },
        {
        "name": "Svalbard and Jan Mayen",
        "number": "+47",
        "countryCode": "SJ"
        },
        {
        "name": "Swaziland",
        "number": "+268",
        "countryCode": "SZ"
        },
        {
        "name": "Sweden",
        "number": "+46",
        "countryCode": "SE"
        },
        {
        "name": "Switzerland",
        "number": "+41",
        "countryCode": "CH"
        },
        {
        "name": "Syrian Arab Republic",
        "number": "+963",
        "countryCode": "SY"
        },
        {
        "name": "Taiwan",
        "number": "+886",
        "countryCode": "TW"
        },
        {
        "name": "Tajikistan",
        "number": "+992",
        "countryCode": "TJ"
        },
        {
        "name": "Tanzania, United Republic of Tanzania",
        "number": "+255",
        "countryCode": "TZ"
        },
        {
        "name": "Thailand",
        "number": "+66",
        "countryCode": "TH"
        },
        {
        "name": "Timor-Leste",
        "number": "+670",
        "countryCode": "TL"
        },
        {
        "name": "Togo",
        "number": "+228",
        "countryCode": "TG"
        },
        {
        "name": "Tokelau",
        "number": "+690",
        "countryCode": "TK"
        },
        {
        "name": "Tonga",
        "number": "+676",
        "countryCode": "TO"
        },
        {
        "name": "Trinidad and Tobago",
        "number": "+1868",
        "countryCode": "TT"
        },
        {
        "name": "Tunisia",
        "number": "+216",
        "countryCode": "TN"
        },
        {
        "name": "Turkey",
        "number": "+90",
        "countryCode": "TR"
        },
        {
        "name": "Turkmenistan",
        "number": "+993",
        "countryCode": "TM"
        },
        {
        "name": "Turks and Caicos Islands",
        "number": "+1649",
        "countryCode": "TC"
        },
        {
        "name": "Tuvalu",
        "number": "+688",
        "countryCode": "TV"
        },
        {
        "name": "Uganda",
        "number": "+256",
        "countryCode": "UG"
        },
        {
        "name": "Ukraine",
        "number": "+380",
        "countryCode": "UA"
        },
        {
        "name": "United Arab Emirates",
        "number": "+971",
        "countryCode": "AE"
        },
        {
        "name": "United Kingdom",
        "number": "+44",
        "countryCode": "GB"
        },
        {
        "name": "United States",
        "number": "+1",
        "countryCode": "US"
        },
        {
        "name": "Uruguay",
        "number": "+598",
        "countryCode": "UY"
        },
        {
        "name": "Uzbekistan",
        "number": "+998",
        "countryCode": "UZ"
        },
        {
        "name": "Vanuatu",
        "number": "+678",
        "countryCode": "VU"
        },
        {
        "name": "Venezuela, Bolivarian Republic of Venezuela",
        "number": "+58",
        "countryCode": "VE"
        },
        {
        "name": "Vietnam",
        "number": "+84",
        "countryCode": "VN"
        },
        {
        "name": "Virgin Islands, British",
        "number": "+1284",
        "countryCode": "VG"
        },
        {
        "name": "Virgin Islands, U.S.",
        "number": "+1340",
        "countryCode": "VI"
        },
        {
        "name": "Wallis and Futuna",
        "number": "+681",
        "countryCode": "WF"
        },
        {
        "name": "Yemen",
        "number": "+967",
        "countryCode": "YE"
        },
        {
        "name": "Zambia",
        "number": "+260",
        "countryCode": "ZM"
        },
        {
        "name": "Zimbabwe",
        "number": "+263",
        "countryCode": "ZW"
        }
    ],
            
};

const getters = {
    telephoneCodes: (state) => state.telephoneCodes,
};

const actions = {
};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
}
